import { Breadcrumb, Button, Col, Form, Row, Select, Steps } from "antd";
import { _adr } from "../../../address";
import { HomeOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import { Content } from "antd/es/layout/layout";
import styles from "./card.module.scss";
import ReactInputMask from "react-input-mask";
import { validateInput } from "../../../tools/tools";
import Iinput from "../../auxiliary/inputs/Input";

const CDCard = () => {
	const [t] = useTranslation("global");
	const [frmValid] = Form.useForm();

	return (
		<>
			<div className="container-main container-cw">
				<div className="holder-top-of-page-content">
					<div className="g-hold-title-of-page">
						<Breadcrumb
							className="breadcrumbs"
							items={[{ href: _adr.Root + _adr.Home, title: <HomeOutlined /> }, { title: t("creditCard.title") }]}
						/>
						<div className="title-page">
							<h3>{t("creditCard.title")}</h3>
							<p></p>
						</div>
					</div>
				</div>
				<div className="g-layout-content">
					<Content className="g-layout-main da-container">
						<div className="g-format-page">
							<div className="g-format-steps">
								<div className="holder-step">
									<Steps
										size="small"
										className="step-wizard"
										current={3}
										responsive
										items={[
											{
												title: "ورود کدملی",
											},
											{
												title: "اطلاعات هویتی",
											},
											{
												title: "آپلود مدارک",
											},
											{
												title: "کارت بانکی",
											},
											{
												title: "بررسی نهایی",
											},
										]}
									/>
								</div>
							</div>
							<div className="g-body-format-page">
								<div className={styles.cardino}>
									<Row>
										<Col xxl={12} xl={12} lg={12} md={24} xs={24} sm={24}>
											<Form form={frmValid} id="frmValid" layout="vertical">
												<Row>
													<Col xxl={12} xl={12} lg={12} md={15} xs={24} sm={24}>
														<Form.Item
															className="input-normal"
															label="شماره کارت"
															rules={[
																validateInput({
																	t: t,
																	validate: true,
																	type: "number",
																	length: 16,
																}),
															]}
															hasFeedback>
															<>
																<ReactInputMask
																	placeholder="شماره کارت را وارد کنید"
																	autoComplete="off"
																	inputMode="numeric"
																	className="msisdn-mask"
																	dir="ltr"
																	mask="9999-9999-9999-9999"
																/>
															</>
														</Form.Item>
													</Col>
												</Row>
												<Row>
													<Col xxl={12} xl={12} lg={12} md={15} xs={24} sm={24}>
														<Form.Item
															className="input-normal"
															label="CVV"
															rules={[
																validateInput({
																	t: t,
																	validate: true,
																	type: "number",
																}),
															]}
															hasFeedback>
															<Iinput placeholder="شماره CVV را وارد کنید" dir="ltr" autoComplete="off" />
														</Form.Item>
													</Col>
												</Row>
												<Row>
													<Col xxl={12} xl={12} lg={12} md={15} xs={24} sm={24}>
														<Row justify={"space-between"}>
															<Col xxl={11} xl={11} lg={11} md={24} xs={24} sm={24}>
																<Form.Item
																	className="input-normal"
																	label="تاریخ انقضا"
																	rules={[
																		validateInput({
																			t: t,
																			validate: true,
																		}),
																	]}
																	hasFeedback>
																	<Select placeholder="روز">
																		{Array(31)
																			.fill("")
																			.map((i, key) => (
																				<Select.Option key={key}>{("0" + (key + 1)).slice(-2)}</Select.Option>
																			))}
																	</Select>
																</Form.Item>
															</Col>
															<Col xxl={11} xl={11} lg={11} md={24} xs={24} sm={24}>
																<Form.Item
																	className="input-normal"
																	label="&nbsp;"
																	rules={[
																		validateInput({
																			t: t,
																			validate: true,
																		}),
																	]}
																	hasFeedback>
																	<Select placeholder="ماه">
																		{Array(12)
																			.fill("")
																			.map((i, key) => (
																				<Select.Option key={key}>{("0" + (key + 1)).slice(-2)}</Select.Option>
																			))}
																	</Select>
																</Form.Item>
															</Col>
														</Row>
													</Col>
												</Row>
											</Form>
										</Col>
										<Col xxl={12}>
											<img src={process.env.PUBLIC_URL + "/assets/images/creditcard.png"} />
										</Col>
									</Row>
								</div>
							</div>
							<div className="g-footer-format-page">
								<div className="holder-button">
									<Button
										// disabled={10 - prof.counterSim > 0 ? false : true}
										form="frmProfile"
										key="submit"
										htmlType="submit"
										className="btn-normal btn-aptel">
										مرحله بعد
									</Button>
									<Button
										type="default"
										className="btn-normal "
										onClick={() => {
											// nav(_adr.Root + _adr.SimCardPurchase.Index + _adr.SimCardPurchase.Kit);
										}}>
										بازگشت
									</Button>
								</div>
							</div>
						</div>
					</Content>
				</div>
			</div>
		</>
	);
};

export default CDCard;
